import "intro.js/introjs.css";

import { Settings } from "luxon";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { setupIntlLocalePolyfill } from "./utils/date/polyfills";

// Configure Luxon to use local timezone and browser locale by default.
// Force Sunday-first for English locales via Unicode extension (fw=sun) so Luxon/MUI align with US expectations.
const browserLocale = navigator?.language || "en-US";
const effectiveLocale = browserLocale.toLowerCase() === "en-us" ? `${browserLocale}-u-fw-sun` : browserLocale;

Settings.defaultZone = "local";
Settings.defaultLocale = effectiveLocale;

setupIntlLocalePolyfill()
  .catch((error) => {
    console.error("Failed to load polyfill:", error);
  })
  .finally(() => {
    createRoot(document.getElementById("root") as HTMLDivElement).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
